export const DEFAULTS = {
    color: 'primary',
    iconType: 'info_outline',
    position: 'right',
};
//# sourceMappingURL=InfoIcon.types.js.map